'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPublication = createPublication;
exports.createPublicationFromMatchingPublications = createPublicationFromMatchingPublications;
exports.findPrices = findPrices;
exports.sortPublications = sortPublications;

var _dateUtils = require('../helpers/dateUtils');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function arePolicyInBookingWindow(dateArrival, cancellationPolicyDays) {
  var bookingWindow = (0, _dateUtils.datesDiff)(Date.now(), dateArrival);
  return bookingWindow >= cancellationPolicyDays;
}

function filterPublicationCancellationPolicy(dateArrival, policies) {
  return Object.keys(policies).filter(function (policyPercent) {
    return arePolicyInBookingWindow(dateArrival, policies[policyPercent]);
  }).reduce(function (acc, policy) {
    acc[policy] = policies[policy];
    return acc;
  }, {});
}

function createPublication(_ref, dateArrival) {
  var partner_id = _ref.partner_id,
      price_per_day = _ref.price_per_day,
      price = _ref.price,
      cancellationPolicy = _ref.cancellation_policy;

  return {
    partner_id: partner_id,
    price_per_day: price_per_day,
    price_total: price,
    cancellation_policy: cancellationPolicy && filterPublicationCancellationPolicy(dateArrival, cancellationPolicy) || null
  };
}

function createPublicationFromMatchingPublications(_ref2) {
  var partner_id = _ref2.partner_id,
      instantly_booking = _ref2.instantly_booking,
      quality_score = _ref2.quality_score,
      cancellationPolicy = _ref2.cancellation_policy;

  return {
    partner_id: partner_id,
    price_per_day: null,
    price_total: null,
    instantly_booking: instantly_booking,
    quality_score: quality_score,
    cancellation_policy: cancellationPolicy || null
  };
}

function findPrices(partners, allPartners) {
  var partnersWithPrice = partners.filter(function (partner) {
    return partner.price_per_day;
  });
  if (partnersWithPrice.length) {
    return sortPublications(partnersWithPrice, allPartners);
  }
  return null;
}

function sortPublications(publications, allPartners) {
  var pubs = [].concat(_toConsumableArray(publications));
  pubs.sort(function (a, b) {
    if (!a.price_per_day) return 1;
    if (!b.price_per_day) return -1;

    return parseFloat(a.price_per_day) - parseFloat(b.price_per_day) || allPartners[a.partner_id] && allPartners[b.partner_id] && allPartners[b.partner_id].cpc - allPartners[a.partner_id].cpc;
  });
  return pubs;
}